import { createRouter, createWebHashHistory } from 'vue-router'
import routes from './routes'

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const ut = localStorage.getItem('ut')
  if (!ut && to.path !== '/login') {
    next({ path: '/login' })
  } else {
    next()
  }
})

export default router
